export default __webpack_public_path__ + "static/life-insurance-bg-28f12ea278d7d2f313a585d4b922fdf0.png";